import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { FIREBASE_PROJECT_ID_PROVIDER } from '@principle-theorem/ng-shared';
import type { IPatient } from '@principle-theorem/principle-core/interfaces';
import { getFirestoreLink, type WithRef } from '@principle-theorem/shared';

@Component({
  selector: 'pr-patient-firestore-button',
  templateUrl: './patient-firestore-button.component.html',
  styleUrl: './patient-firestore-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PatientFirestoreButtonComponent {
  private _projectId = inject(FIREBASE_PROJECT_ID_PROVIDER);
  patient = input.required<WithRef<IPatient>>();

  viewInFirestore(patient: WithRef<IPatient>): void {
    window.open(getFirestoreLink(this._projectId, patient.ref), '_blank');
  }
}
